import { Icon } from '@kinesis/bungle';

/* eslint-disable max-len */
const IconKey = (props: IconKeyProps) => {
  const { magnitude = 'small' } = props;
  return (
    <Icon type='custom' magnitude={magnitude}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1024 1024'
        width='1024'
        height='1024'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M659.076 418.4L564 513.476L563.696 513.786C591.111 552.107 605.876 597.932 605.876 646C605.876 706.9 582.176 764.2 539.076 807.2C496.076 850.3 438.776 874 377.876 874C316.976 874 259.676 850.3 216.676 807.2C173.576 764.2 149.876 706.9 149.876 646C149.876 585.1 173.576 527.8 216.676 484.8C259.676 441.7 316.976 418 377.876 418C425.946 418 471.772 432.766 510.094 460.182L510.194 460.082L818.076 152.2C821.176 149.1 826.276 149.1 829.376 152.2L871.676 194.5C873.165 196.004 874 198.034 874 200.15C874 202.266 873.165 204.296 871.676 205.8L806.376 271.1L868.676 333.4C870.166 334.923 871.001 336.969 871.001 339.1C871.001 341.231 870.166 343.277 868.676 344.8L828.876 384.6C827.353 386.09 825.307 386.925 823.176 386.925C821.045 386.925 818.999 386.09 817.476 384.6L755.176 322.3L710.276 367.2L772.576 429.5C774.066 431.023 774.901 433.069 774.901 435.2C774.901 437.331 774.066 439.377 772.576 440.9L732.776 480.7C731.253 482.19 729.207 483.025 727.076 483.025C724.945 483.025 722.899 482.19 721.376 480.7L659.076 418.4ZM305 779C338.137 779 365 752.137 365 719C365 685.863 338.137 659 305 659C271.863 659 245 685.863 245 719C245 752.137 271.863 779 305 779Z'
          fill='currentColor'
        />
      </svg>
    </Icon>
  );
};

export type IconKeyProps = {
  magnitude?: string;
};

export { IconKey };
/* eslint-enable max-len */
